import { IAppSetting } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { List } from '@models/list';
import { AppSettingProviderService } from '@services/settings';
import { Observable, Subject } from 'rxjs';
import { ICustomFilter } from '../../../schema/interfaces/ICustomFilter';

@Injectable({
  providedIn: 'root'
})
export class ResponsibilityFilterService implements ICustomFilter {
  name = 'Mobile.FilterResponsibility';
  view = 'listcallcards/CardListResponsibilityFilter';

  private responsibilitiesToFilter: IAppSetting<string[]> = null;

  private _onSave = new Subject<void>();
  get $onSave(): Observable<void> {
    return this._onSave.asObservable();
  }

  private boundFilter: (callcard: CallCard) => boolean;

  constructor(private appSettingProvider: AppSettingProviderService) {}

  setup(defaultValue: string[] = []) {
    this.boundFilter = this.filter.bind(this);
    this.appSettingProvider.getSetting('ResponsibilitiesToFilter', defaultValue, true).subscribe(appSetting => {
      this.responsibilitiesToFilter = appSetting;
    });
  }

  initFilter(cards: List<CallCard>) {
    cards.addFilter(this.boundFilter);
  }

  removeFilter(cards: List<CallCard>) {
    cards.removeFilter(this.boundFilter);
  }

  private filter(callcard: CallCard): boolean {
    if (this.responsibilitiesToFilter.current.length) {
      return this.responsibilitiesToFilter.current.indexOf(callcard.event.NodeTag) !== -1;
    }
    return true;
  }

  save() {
    this._onSave.next();
  }

  hasActiveFilter(): boolean {
    return this.responsibilitiesToFilter.current.length > 0;
  }
}
